import React, { useState, useEffect } from 'react'
import MyDonutChart from './MyDonutChart'
import chroma from 'chroma-js'

const ProfessionChart = ({ broadcategory, broadcategorycounts, titles }) => {
  const professions = [
    { id: 0, name: 'Professions' },
    ...broadcategory.map((item, index) => ({
      id: index + 1,
      name: item.broad_category,
    })),
  ]

  const [selectedProfession, setSelectedProfession] = useState(professions[0])
  const [filteredTitles, setFilteredTitles] = useState([])
  const [otherData, setOtherData] = useState([])
  const [isOtherSelected, setIsOtherSelected] = useState(false)

  useEffect(() => {
    if (selectedProfession.name === 'Professions') {
      const colors = chroma.scale('Set3').mode('lch').colors(broadcategorycounts.length)
      setFilteredTitles(
        broadcategorycounts.map((item, index) => ({
          title: item.broad_category,
          total: item.total,
          color: colors[index],
        }))
      )
    } else if (selectedProfession && !isOtherSelected) {
      const filtered = titles.filter((group) => group.broad_category === selectedProfession.name)

      // Sort categories by total in descending order
      const sortedTitles = filtered.sort((a, b) => b.total - a.total)

      // Get the top 10 categories
      const topFiveTitles = sortedTitles.slice(0, 10)

      // All remaining categories are grouped under "Other"
      const remainingTitles = sortedTitles.slice(10)

      const otherTotal = remainingTitles.reduce((acc, title) => acc + title.total, 0)

      setFilteredTitles([
        ...topFiveTitles,
        { title: 'Other', total: otherTotal, color: '#E83356' }, // color for "Other"
      ])

      setOtherData(remainingTitles)
    }
  }, [selectedProfession, titles, isOtherSelected, broadcategorycounts])

  const handleOtherClick = () => {
    const colors = chroma.scale('Set3').mode('lch').colors(otherData.length)
    setIsOtherSelected(true)
    setFilteredTitles(
      otherData.map((data, index) => ({
        ...data,
        color: colors[index],
      }))
    )
  }

  const handleChartClick = (label) => {
    if (label === 'Other') {
      handleOtherClick()
    }
  }

  const colors = chroma.scale('Set3').mode('lch').colors(filteredTitles.length)

  const chartData = {
    labels: filteredTitles.map((group) => group.title),
    datasets: [
      {
        label: selectedProfession?.name || 'Other',
        data: filteredTitles.map((group) => group.total),
        backgroundColor: colors,
        borderColor: colors.map((color) => chroma(color).darken(1).hex()),
        borderWidth: 1,
      },
    ],
  }

  const options = {
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'start', // Align to the start (left)
        labels: {
          padding: 7, // Adjust padding as needed
          boxWidth: 8, // Adjust the box size of the legend
          boxHeight: 8, // Adjust the box size of the legend
        },
      },
    },
  }

  return (
    <div className="relative flex flex-col lg:flex-row content-center items-center z-10">
      <div className="w-full lg:w-1/2 mb-8 md:mb-0">
        <ul>
          {professions.map((prof) => (
            <React.Fragment key={prof.id}>
              <li
                className={`cursor-pointer p-3 ${
                  selectedProfession.id === prof.id ? 'text-pointed' : 'hover:bg-gray-200'
                }`}
                onClick={() => {
                  setSelectedProfession(prof)
                  setIsOtherSelected(false) // Reset other selection when a new profession is selected
                  setOtherData([]) // Reset other data when a new profession is selected
                }}
              >
                {prof.name}
              </li>
              <hr
                className={`h-px my-2 ${
                  selectedProfession.id === prof.id ? 'bg-pointed' : 'bg-gray-200'
                } border-0 dark:bg-gray-700`}
              />
            </React.Fragment>
          ))}
        </ul>
      </div>
      <div className="w-full lg:w-1/2 md:ml-12">
        <MyDonutChart data={chartData} options={options} onClick={handleChartClick} />
      </div>
    </div>
  )
}

export default ProfessionChart
